import { render, staticRenderFns } from "./NewsCardPreview.vue?vue&type=template&id=293997df&scoped=true&"
import script from "./NewsCardPreview.vue?vue&type=script&lang=js&"
export * from "./NewsCardPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewsCardPreview.vue?vue&type=style&index=0&id=293997df&lang=scss&scoped=true&"
import style1 from "./NewsCardPreview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293997df",
  null
  
)

export default component.exports